import {CREATOR_STATUS} from './creatorTabTypes';
import type {CreatorStatus} from './creatorTabTypes';

/**
 * The grid-view creator card shows a single primary CTA next to the `…` menu.
 * Its action depends on the active status filter:
 *  - applications → Accept the creator's proposal
 *  - hired        → Message the creator
 *  - declined     → View the creator's profile
 *
 * (Re-accepting a declined creator is not a supported V2 transition, so it is
 * intentionally not offered here.)
 */
export type CreatorCardCtaId = 'accept' | 'message' | 'view';

export type CreatorCardCtaConfig = {
  id: CreatorCardCtaId;
  /** Untranslated label — call `translate()` at the render site. */
  label: string;
};

const CTA_CONFIG_BY_STATUS: Record<CreatorStatus, CreatorCardCtaConfig> = {
  [CREATOR_STATUS.Applications]: {id: 'accept', label: 'Accept'},
  [CREATOR_STATUS.Hired]: {id: 'message', label: 'Message'},
  [CREATOR_STATUS.Declined]: {id: 'view', label: 'View'},
};

export function getCreatorCardCtaConfig(
  status: CreatorStatus
): CreatorCardCtaConfig {
  return CTA_CONFIG_BY_STATUS[status];
}
